import * as React from 'react';

import { stringKeyToTuple } from 'js/lib/stringKeyTuple';

import { VisuallyHidden } from '@coursera/cds-core';

import EnrollmentChoiceTypes from 'bundles/enroll-course/common/EnrollmentChoiceTypes';
import {
  choiceTypeToHandleSubmitPromise,
  submitEnrollmentPromise,
} from 'bundles/enroll-course/lib/enrollmentChoiceUtils';
import type { ApiError } from 'bundles/enroll/utils/errorUtils';
import Icon from 'bundles/iconfont/Icon';
import TrackedButton from 'bundles/page/components/TrackedButton';
import ProductTypeObject from 'bundles/payments/common/ProductType';

import _t from 'i18n!nls/enroll';

import 'css!./__styles__/CredentialTrackSubscriptionEnrollButton';

type Props = {
  productType?: string;
  productId?: string | null;
  promoCode?: string;
  onError: (error: ApiError) => void;
  onClick?: () => void;
};

type State = {
  enrolling: boolean;
};

class CredentialTrackSubscriptionEnrollButton extends React.Component<Props, State> {
  state = {
    enrolling: false,
  };

  handleError = (error: ApiError) => {
    const { onError } = this.props;
    this.setState(() => ({ enrolling: false }));
    onError(error);
  };

  handleClick = () => {
    const { productType, productId, promoCode, onClick } = this.props;
    if (!productId || !productType) {
      return;
    }

    onClick?.();

    this.setState(() => ({ enrolling: true }));

    const [, productItemId] = stringKeyToTuple(productId);
    const options = { credentialTrackProductId: productItemId, productType };
    const handleSubmitPromise =
      productType === ProductTypeObject.CREDENTIAL_TRACK
        ? choiceTypeToHandleSubmitPromise[EnrollmentChoiceTypes.ENROLL_THROUGH_CREDENTIALTRACK]
        : choiceTypeToHandleSubmitPromise[EnrollmentChoiceTypes.ENROLL_THROUGH_CREDENTIALTRACK_SUBSCRIPTION];

    submitEnrollmentPromise({
      handleSubmitPromise,
      options,
      promoCode,
    }).catch(this.handleError);
  };

  renderButtonContent = () => {
    const { enrolling } = this.state;

    if (enrolling) {
      return (
        <div role="alert" aria-live="polite">
          <Icon name="spinner" spin />
          <VisuallyHidden component="span" className="rc-A11yScreenReaderOnly">
            {_t('Loading')}
          </VisuallyHidden>
        </div>
      );
    } else {
      return _t('Continue');
    }
  };

  render() {
    const { productId } = this.props;
    const { enrolling } = this.state;
    const trackingName = 'enroll_credential_track_button';

    return (
      <div className="rc-CredentialTrackSubscriptionEnrollButton horizontal-box align-items-absolute-center m-t-3">
        <TrackedButton
          trackingName={trackingName}
          className="primary enroll-button"
          onClick={this.handleClick}
          disabled={enrolling || !productId}
        >
          {this.renderButtonContent()}
        </TrackedButton>
      </div>
    );
  }
}

export default CredentialTrackSubscriptionEnrollButton;
